import React, { useEffect, useState, useRef, createElement } from 'react';
import { CountdownTimer } from './CountdownTimer';
import { RegistrationModal } from './RegistrationModal';
import { CalendarIcon, ClockIcon, GiftIcon } from 'lucide-react';
export function Hero({
  isPaused,
  setShowThankYou
}: {
  isPaused: boolean;
  setShowThankYou: (show: boolean) => void;
}) {
  const playerRef = useRef<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleSuccess = () => {
    setIsModalOpen(false);
    setShowThankYou(true);
  };
  const handleOpenModal = () => {
    setIsModalOpen(true);
    if (playerRef.current) {
      playerRef.current.pause();
    }
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  useEffect(() => {
    // Load Wistia player scripts
    const script1 = document.createElement('script');
    script1.src = 'https://fast.wistia.com/player.js';
    script1.async = true;
    document.head.appendChild(script1);
    const script2 = document.createElement('script');
    script2.src = 'https://fast.wistia.com/embed/1r1ngrgitd.js';
    script2.async = true;
    script2.type = 'module';
    document.head.appendChild(script2);
    // Wait for Wistia to load and get player reference
    const checkWistia = setInterval(() => {
      if (window.Wistia) {
        const player = window.Wistia.api('1r1ngrgitd');
        if (player) {
          playerRef.current = player;
          clearInterval(checkWistia);
        }
      }
    }, 100);
    return () => {
      clearInterval(checkWistia);
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, []);
  useEffect(() => {
    if (playerRef.current && isPaused) {
      playerRef.current.pause();
    }
  }, [isPaused]);
  return <section className="text-center" data-id="element-140">
      <style dangerouslySetInnerHTML={{
      __html: `
          wistia-player[media-id='1r1ngrgitd']:not(:defined) { 
            background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/1r1ngrgitd/swatch'); 
            display: block; 
            filter: blur(5px); 
            padding-top:56.25%; 
          }
          wistia-player::part(time) {
            display: none !important;
          }
          wistia-player::part(playbar-time) {
            display: none !important;
          }
          .wistia_embed .w-chrome .w-controlbar-above .w-controlbar .w-controlbar-left .w-time {
            display: none !important;
          }
          .video-container {
            position: relative;
            z-index: 10;
            min-height: 200px;
          }
          .geometric-grid {
            position: absolute;
            width: 100%;
            height: 200px;
            overflow: hidden;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            z-index: 0;
            pointer-events: none;
          }
          .geometric-grid::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 200%;
            height: 300px;
            background-image: 
              linear-gradient(90deg, rgba(239, 68, 68, 0.3) 2px, transparent 2px),
              linear-gradient(0deg, rgba(239, 68, 68, 0.3) 2px, transparent 2px);
            background-size: 40px 40px;
            transform: translate(-50%, -50%) perspective(500px) rotateX(60deg);
            transform-origin: center center;
            mask-image: radial-gradient(ellipse at center, black 35%, transparent 85%);
            -webkit-mask-image: radial-gradient(ellipse at center, black 35%, transparent 85%);
          }
          .geometric-grid::after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 3px;
            height: 3px;
            background: rgba(239, 68, 68, 0.9);
            border-radius: 50%;
            box-shadow: 
              0 0 6px rgba(239, 68, 68, 0.8),
              0 0 10px rgba(239, 68, 68, 0.6),
              80px 40px 0 rgba(239, 68, 68, 0.9),
              80px 40px 6px rgba(239, 68, 68, 0.8),
              -80px -40px 0 rgba(239, 68, 68, 0.9),
              -80px -40px 6px rgba(239, 68, 68, 0.8);
            transform: translate(-50%, -50%) perspective(500px) rotateX(60deg);
            animation: laserBeamHorizontal 3s linear infinite;
          }
          .geometric-grid .vertical-beams {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 3px;
            height: 3px;
            background: rgba(239, 68, 68, 0.9);
            border-radius: 50%;
            box-shadow: 
              0 0 6px rgba(239, 68, 68, 0.8),
              0 0 10px rgba(239, 68, 68, 0.6),
              40px 80px 0 rgba(239, 68, 68, 0.9),
              40px 80px 6px rgba(239, 68, 68, 0.8),
              -40px -80px 0 rgba(239, 68, 68, 0.9),
              -40px -80px 6px rgba(239, 68, 68, 0.8);
            transform: translate(-50%, -50%) perspective(500px) rotateX(60deg);
            animation: laserBeamVertical 3.5s linear infinite;
          }
          @keyframes laserBeamHorizontal {
            0%, 100% {
              transform: translate(-50%, -50%) perspective(500px) rotateX(60deg) translateX(-200px);
              opacity: 0;
            }
            10% {
              opacity: 1;
            }
            90% {
              opacity: 1;
            }
            100% {
              transform: translate(-50%, -50%) perspective(500px) rotateX(60deg) translateX(200px);
              opacity: 0;
            }
          }
          @keyframes laserBeamVertical {
            0%, 100% {
              transform: translate(-50%, -50%) perspective(500px) rotateX(60deg) translateY(150px);
              opacity: 0;
            }
            10% {
              opacity: 1;
            }
            90% {
              opacity: 1;
            }
            100% {
              transform: translate(-50%, -50%) perspective(500px) rotateX(60deg) translateY(-150px);
              opacity: 0;
            }
          }
          @media (min-width: 768px) {
            .geometric-grid {
              height: 400px;
            }
            .geometric-grid::before {
              background-size: 60px 60px;
              height: 500px;
            }
            .geometric-grid::after {
              width: 4px;
              height: 4px;
              box-shadow: 
                0 0 8px rgba(239, 68, 68, 0.8),
                0 0 12px rgba(239, 68, 68, 0.6),
                120px 60px 0 rgba(239, 68, 68, 0.9),
                120px 60px 8px rgba(239, 68, 68, 0.8),
                240px 120px 0 rgba(239, 68, 68, 0.9),
                240px 120px 8px rgba(239, 68, 68, 0.8),
                -120px -60px 0 rgba(239, 68, 68, 0.9),
                -120px -60px 8px rgba(239, 68, 68, 0.8),
                -240px -120px 0 rgba(239, 68, 68, 0.9),
                -240px -120px 8px rgba(239, 68, 68, 0.8);
              animation: laserBeamHorizontal 3s linear infinite;
            }
            .geometric-grid .vertical-beams {
              width: 4px;
              height: 4px;
              box-shadow: 
                0 0 8px rgba(239, 68, 68, 0.8),
                0 0 12px rgba(239, 68, 68, 0.6),
                60px 120px 0 rgba(239, 68, 68, 0.9),
                60px 120px 8px rgba(239, 68, 68, 0.8),
                -60px 180px 0 rgba(239, 68, 68, 0.9),
                -60px 180px 8px rgba(239, 68, 68, 0.8),
                120px -60px 0 rgba(239, 68, 68, 0.9),
                120px -60px 8px rgba(239, 68, 68, 0.8);
            }
            .video-container {
              min-height: 400px;
            }
            @keyframes laserBeamHorizontal {
              0%, 100% {
                transform: translate(-50%, -50%) perspective(500px) rotateX(60deg) translateX(-300px);
                opacity: 0;
              }
              10% {
                opacity: 1;
              }
              90% {
                opacity: 1;
              }
              100% {
                transform: translate(-50%, -50%) perspective(500px) rotateX(60deg) translateX(300px);
                opacity: 0;
              }
            }
            @keyframes laserBeamVertical {
              0%, 100% {
                transform: translate(-50%, -50%) perspective(500px) rotateX(60deg) translateY(250px);
                opacity: 0;
              }
              10% {
                opacity: 1;
              }
              90% {
                opacity: 1;
              }
              100% {
                transform: translate(-50%, -50%) perspective(500px) rotateX(60deg) translateY(-250px);
                opacity: 0;
              }
            }
          }
        `
    }} data-id="element-141" />

      {/* Event Date/Time Info Bar - Integrated Design */}
      <div className="bg-gray-800 bg-opacity-30 backdrop-blur-sm border-l-4 border-red-500 py-4 px-6 mb-6 md:mb-8" data-id="element-142">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-8" data-id="element-143">
          <div className="flex items-center gap-2" data-id="element-144">
            <CalendarIcon className="h-5 w-5 text-red-400" data-id="element-145" />
            <span className="text-white font-semibold text-sm sm:text-base" data-id="element-146">
              Martes, 6 de Enero
            </span>
          </div>
          <div className="hidden sm:block w-px h-6 bg-gray-600" data-id="element-147"></div>
          <div className="flex items-center gap-2" data-id="element-148">
            <ClockIcon className="h-5 w-5 text-red-400" data-id="element-149" />
            <span className="text-white font-semibold text-sm sm:text-base" data-id="element-150">
              7:00 PM (Hora del Este)
            </span>
          </div>
        </div>
      </div>

      <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4 text-red-500 leading-tight px-4" style={{
      fontFamily: 'Poppins, sans-serif'
    }} data-id="element-151">
        Masterclass Gratuita: Cómo Vender Productos Digitales Con IA
      </h1>

      <p className="text-sm md:text-base text-gray-400 px-4 mb-4" data-id="element-152">
        Descarga la guia de implementacion
      </p>

      <div className="flex justify-center relative mb-6 md:mb-8" data-id="element-153">
        <div className="geometric-grid" data-id="element-154">
          <div className="vertical-beams" data-id="element-155"></div>
        </div>
        <div className="w-full max-w-3xl px-4 video-container" data-id="element-156">
          <div className="relative rounded-lg md:rounded-2xl p-0.5 md:p-1 bg-gradient-to-br from-gray-800/50 to-gray-900/50 shadow-2xl aspect-video" data-id="element-157">
            <wistia-player media-id="1r1ngrgitd" aspect="1.7777777777777777" data-id="element-158"></wistia-player>
          </div>
        </div>
      </div>

      {/* Special Gift Info Bar - Integrated Design */}
      <div className="bg-gray-800 bg-opacity-30 backdrop-blur-sm border-l-4 border-yellow-500 py-4 px-6 mb-6 max-w-3xl mx-auto" data-id="element-159">
        <div className="flex items-start sm:items-center gap-3" data-id="element-160">
          <GiftIcon className="h-6 w-6 text-yellow-400 flex-shrink-0 mt-0.5 sm:mt-0" data-id="element-161" />
          <div className="text-left" data-id="element-162">
            <p className="text-yellow-400 font-bold text-xs uppercase tracking-wide mb-1" data-id="element-163">
              Regalo Exclusivo (Valorado en $297)
            </p>
            <p className="text-white text-sm sm:text-base leading-relaxed" data-id="element-164">
              Tu{' '}
              <span className="font-bold text-yellow-400" data-id="element-165">REGALO GRATIS:</span>{' '}
              Recurso sorpresa para implementar lo que aprendas en la
              masterclass + Guía de Implementación automática (VALORADA EN $97).
              Solo para quienes asistan en vivo.
            </p>
          </div>
        </div>
      </div>

      <div className="flex justify-center mb-6 md:mb-8" data-id="element-166">
        <div className="w-full max-w-3xl px-4" data-id="element-167">
          <button onClick={handleOpenModal} className="w-full bg-red-600 hover:bg-red-700 active:bg-red-800 text-white text-lg sm:text-xl md:text-2xl font-bold py-4 md:py-5 px-8 md:px-12 shadow-2xl transform hover:scale-105 active:scale-95 transition-all duration-300 flex items-center justify-center touch-manipulation" data-id="element-168">
            RESERVA TU LUGAR GRATIS
            <span className="ml-2 md:ml-3 text-xl md:text-2xl" data-id="element-169">→</span>
          </button>
        </div>
      </div>

      <div className="flex justify-center mb-6 md:mb-8" data-id="element-170">
        <div className="w-full max-w-3xl px-4" data-id="element-171">
          <img src="https://cdn.magicpatterns.com/uploads/1cVYLqSP4PbWDgrRQPU8aV/tmp5djoo1mh.webp" alt="Regalo Gratis - Guía Completa de Implementación" className="w-full h-auto" data-id="element-172" />
        </div>
      </div>

      <div className="mb-6 md:mb-8" data-id="element-173">
        <CountdownTimer data-id="element-174" />
      </div>

      <RegistrationModal isOpen={isModalOpen} onClose={handleCloseModal} onSuccess={handleSuccess} data-id="element-175" />
    </section>;
}
declare global {
  interface Window {
    Wistia: any;
  }
}